export default {
    new_migration_account: 'Account',
    new_migration_accounts: 'Account',
    new_migration_groups: 'Groups',
    new_migration_landmarks: 'Landmarks',
    new_migration_landmark_groups: 'Landmark Groups',
    new_migration_server: 'Server',
    new_migration_account_name: 'Account Name',
    new_migration_no_data_available: 'No data available',
    new_migration_entity_to_migrate: 'Entity to Migrate',
    new_migration_contacts: 'Contacts',
    new_migration_categories: 'Categories',
    new_migration_behavior: 'Behavior',
    new_migration_users: 'Users',
    new_migration_drivers: 'Drivers',
    new_migration_devices: 'Devices',
    new_migration_geofences: 'Geofences',
    new_migration_maintenance: 'Maintenance',
    new_migration_import: 'Import',
    new_migration_import_from_p4: 'Import Account',
    new_migration_import_from_account: 'Import From Account',
    new_migration_records_found: 'Records Found',
    MigrationExists: "Migration Exists",
    MigrationNotExists: "Migration Not Exists",
    MigrationNotExists_AccountNameExists: "Migration Not Exists, but Account Name Exists",
    new_migration_success_message: "Migration started to be executed",
    new_migration_error_message: "Unable to run the migration due to an error",
    new_migration_warning_message: "It is necessary to verify that the name of the selected P4 and PX accounts match",
    new_migration_account_registered: "There is already an account registered under the name of",
    new_migration_in_px: "in PX",
    new_migration_verify_accounts: "It is necessary to verify that the name of the selected P4 and PX accounts match",
    new_migration_pair_with_this_px: "Pair With This PX Account",
    new_migration_alerts: "Alerts",
    new_migration_speed_override: "Speed Override",
    new_migration_entities: "Entities",
    new_migration_source: "Source",
    new_migration_units_novidfleet: 'Units (NO Vidfleet)',
    new_migration_units_vidfleet: 'Units (Vidfleet)',
    new_migration_assets: 'Assets',
    new_migration_asset_subtypes: 'Asset Subtypes',
    new_migration_tags: 'Tags',
    new_migration_speed_overrides: 'Speed Overrides',
    new_migration_all: 'All',
    new_migration_selected: 'Selected',
    new_migration_selected_for: "At least one entity must be selected for",
    new_migration_title: 'Migration Entities TSO',
    new_migration_error_messages: "Entities could not be synchronized",
    new_migration_transaction_request_message: "The migration request has been received. Click here to see the import status",
    new_migration_gtc_account_name: "GTC Account Name",
    new_migration_ignition_account_name: "Ignition Account Name",
    new_migration_mode: "Mode",
    new_migration_pair_with_this_gtc: "Pair with this GTC account",
    new_migration_select_integration_mode: "Select Integration Mode",
    new_migration_preview_mode: "Preview Mode",
    new_migration_preview_mode_desc: "Read-only data for testing before full migration",
    new_migration_upgrade_mode: "Upgrade Mode",
    new_migration_upgrade_mode_desc: "Full migration - all entities sync automatically every 24 hours",

    new_migration_convert_to_upgrade_title: "Convert to Upgrade Mode?",
    new_migration_convert_to_upgrade_desc: "You are about to convert this integration from Preview Mode to Upgrade Mode. This action cannot be undone.",
    new_migration_what_will_happen: "What will happen:",
    new_migration_upgrade_bullet_sync_all_entities: "All entities will be synced automatically",
    new_migration_upgrade_bullet_sync_every_24h: "Data will sync continuously every 24 hours",
    new_migration_upgrade_bullet_no_switch_back: "You cannot switch back to Preview Mode",
    new_migration_upgrade_bullet_permanent: "Changes will be permanent",
    new_migration_are_you_sure: "Are you sure you want to proceed?",
    new_migration_cancel: "Cancel",
    new_migration_confirm_convert_upgrade: "Yes, Convert to Upgrade Mode",

    new_migration_mode_label: "Mode",
    new_migration_select_entities_to_sync: "Select Entities to Sync",
    new_migration_units: "Units",
    new_migration_assets_non_tcu: "Assets (non-TCU)",
    new_migration_roles: "Roles",
    new_migration_permissions: "Permissions",
    new_migration_divisions: "Divisions",
    new_migration_asset_subtypes: "Asset Subtypes",
    new_migration_zones_landmarks: "Zones (Landmarks)"
    ,
    new_migration_entities_auto_synced: "Entities (Auto-synced)",
    new_migration_upgrade_entities_locked: "In Upgrade Mode, all entities are automatically synced and cannot be customized.",
    new_migration_account_already_linked: "This GTC account is already linked to a target account and this relationship cannot be modified.",
    new_migration_already_upgraded_desc: "This account has already been upgraded to 'upgrade' mode and cannot be modified.",
    new_migration_already_upgraded: "Already Upgraded Account",
    new_migration_preview_only_upgrade_desc: "This account is in 'preview' mode. It can only be upgraded to 'upgrade' mode.",
    new_migration_preview_units_only_warning: "In preview mode, if you select Units, you must also select at least one other entity (Assets, Drivers, or Users).",
    new_migration_upgrade_already_done: "Migration marked as upgrade already performed. Cannot continue with the process.",
    new_migration_warning_multiple_legacy_accounts: "The company selected is a multi-account company only single companies can be migrated at the moment.",
    new_migration_gtc_account_missing_account_code: "The selected GTC account does not have an Account Code and cannot be used for migration."
};

